var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrashDeleteBin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M10.759 14h-5.52a1.334 1.334 0 0 1-1.33-1.235L3.31 4.667h9.356l-.578 8.094A1.334 1.334 0 0 1 10.759 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M8 7.333v4M2.667 4.667h10.666"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m11.333 4.667-.675-1.802A1.33 1.33 0 0 0 9.409 2H6.59c-.555 0-1.053.345-1.248.865l-.675 1.802M10.287 7.333l-.287 4M5.713 7.333l.287 4"
})));
export default SvgTrashDeleteBin;